var h = Object.defineProperty;
var p = (r, e, t) => e in r ? h(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => (p(r, typeof e != "symbol" ? e + "" : e, t), t);
import u from "./FormFieldAttr.js";
class g extends u {
  /**
   * @constructor
   * @param {string} name 绑定的属性名
   * @param {string} label 标签名
   * @param {string} placeholder 为空时的占位字符
   * @param {SelectOption[]} options 选项列表
   * @param {boolean} [required=false] 是否必填
   * @param {Array} [rules=[]] 校验规则
   */
  constructor(t = "", o = "", a = "", l = [], i = !1, c = []) {
    super(t, o);
    /**
     * 是否必填
     * @type {boolean}
     */
    s(this, "required");
    /**
     * 必填的校验规则
     * @type {Array<{message: string, required: boolean, trigger: string} | any>}
     */
    s(this, "rules");
    /**
     * 为空时的占位文字
     * @type {string}
     */
    s(this, "placeholder");
    /**
     * 选项
     * @type {SelectOption[]}
     */
    s(this, "options");
    this.required = i, this.rules = c.concat(
      c.some(({ required: d }) => d) ? [] : [{ required: i, message: `请填写${o}`, trigger: "change" }]
    ), this.placeholder = a, this.options = l;
  }
}
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/selectAttribute.js
// module id = 1248
// module chunks = 67